import React from "react";

export const Footer = () => {
  return (
    <div className="lis-footer">
      <div className="footer_item">
        <div className="lis-footer_git">
          <a href="https://github.com/lishal" target="__blank">
            <i className="fa fa-github"></i>
          </a>
        </div>
        <div className="lis-footer_fb">
          <a href="https://www.facebook.com/lishalbhari" target="__blank">
            <i className="fa fa-facebook"></i>
          </a>
        </div>
        <div className="lis-footer_ig">
          <a href="https://www.instagram.com/all_li/" target="__blank">
            <i className="fa fa-instagram"></i>
          </a>
        </div>
      </div>
    </div>
  );
};
